import { FontWeights, getTheme, IButtonStyles, Icon, IIconProps, mergeStyleSets } from "@fluentui/react";
import React from "react";

export function useDropDownModalStyles(isComponentInstance: boolean) {
  const theme = getTheme();

  const contentStyles = mergeStyleSets({
    header: [
      theme.fonts.xLarge,
      {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "12px 12px 14px 24px",
      },
    ],
    body: {
      flex: "4 4 auto",
      padding: "0 24px 24px 24px",
      overflowY: "hidden",
      selectors: {
        p: { margin: "14px 0" },
        "p:first-child": { marginTop: 0 },
        "p:last-child": { marginBottom: 0 },
      },
    },
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
    },
  });

  const iconButtonStyles: Partial<IButtonStyles> = {
    root: {
      color: theme.palette.neutralPrimary,
      marginLeft: "auto",
      marginTop: "4px",
      marginRight: "10px",
    },
    rootHovered: {
      color: theme.palette.neutralDark,
    },
  };

  const cancelIcon: IIconProps = { iconName: "Cancel" };

  const onRenderCaretDown = (): React.JSX.Element => {
    return isComponentInstance ? null : <Icon iconName="More" />;
  };

  return { contentStyles, iconButtonStyles, cancelIcon, onRenderCaretDown };
}
